<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
		<v-col class="pa-0">
            <show v-if="this.models.container"
                :id="id"
                model-def="containers"
                model-class="container"
                :models="models"
                :infos="infos"
                :activities="true"
                :maillogs="false"
                :fileuploader="true">
            </show>
        </v-col>
    </v-row>
</template>

<script>

    export default {
        name: 'container',
        props: {
            id: Number,
        },

        data() {
            return {
				infos: {},
				models: {},
				relations: {},		
            }
        },

        methods: {
            initialization() {
                this.axios.get('containers/' + this.id).then(response => {
                    // get body data
                    this.$set(this, 'models', response.data.models)
                    this.$set(this, 'infos', response.data.infos)
                    this.$set(this, 'relations', response.data.relations)
                    this.$store.commit('endProgress')

                }, response => {
                    // error callback
                })
            }
        },

        created() {
            this.initialization()
        },
      
    }
</script>